import { render, staticRenderFns } from "./ClientMailReview.vue?vue&type=template&id=00b121ea"
import script from "./ClientMailReview.vue?vue&type=script&lang=js"
export * from "./ClientMailReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports